<template>
  <div class="mt-8 w-12/12 bg-green-700 mx-auto" data-v-6c5d7da5="">
    <div class="ml-4 text-white py-1 lg:py-2 lg:text-lg flex font-bold">
      <slot />
    </div>
  </div>
</template>
